import { TextField } from "@mui/material";
import "./LotDrugTable.css";

const LotDrugTable = ({ drugList, quantities, handleQuantityChange }) => {
  return (
    <>
      <table
        className="drug-quantity-table-container"
        style={{
          marginBottom: "10px",
        }}
      >
        <thead className="drug-quantity-table-header">
          <tr>
            <th className="drug-quantity-header-item">Drug Type</th>
            <th className="drug-quantity-header-item">Available Quantity</th>
            <th className="drug-quantity-header-item long-input-field">
              Quantity to Order
            </th>
          </tr>
        </thead>
        <tbody>
          {drugList &&
            drugList?.length > 0 &&
            drugList?.map((drug) => (
              <tr key={drug.drugTypeId}>
                <td className="drug-quantity-item">{drug.drugName}</td>
                <td className="drug-quantity-item">{drug.availableQuantity}</td>
                <td className="drug-quantity-item">
                  <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "100%" }}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={quantities[drug.drugTypeId] ?? ""}
                    onChange={(e) =>
                      handleQuantityChange(drug.drugTypeId, e.target.value)
                    }
                  />
                  <div className="error-container">
                    {quantities[drug.drugTypeId] > drug.availableQuantity
                      ? "Quantity exceeds available stock"
                      : ""}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default LotDrugTable;
